module.exports = __webpack_public_path__ + "img/f-11.jpg";